import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/action-settings.js";
import "@ui5/webcomponents-icons/dist/building.js";
import "@ui5/webcomponents-icons/dist/create-form.js";
import "@ui5/webcomponents-icons/dist/line-charts.js";
import "@ui5/webcomponents-icons/dist/money-bills.js";
import "@ui5/webcomponents-icons/dist/official-service.js";
import "@ui5/webcomponents-icons/dist/project-definition-triangle-2.js";
import "@ui5/webcomponents-icons/dist/settings.js";
import "@ui5/webcomponents-icons/dist/wrench.js";

import { opsPermissions, opsSettingsGroup } from "./permissions";

/** Operations entries of the navigation registry (group `ops`, docs/contracts/operations.md §5). */
export const opsNavigation: readonly NavigationEntry[] = [
  {
    key: "ops.offers",
    labelKey: "nav.opsOffers",
    icon: "create-form",
    path: "/ops/offers",
    permission: opsPermissions.offerView,
  },
  {
    key: "ops.contracts",
    labelKey: "nav.opsContracts",
    icon: "official-service",
    path: "/ops/contracts",
    permission: opsPermissions.contractView,
  },
  {
    key: "ops.billing",
    labelKey: "nav.opsBilling",
    icon: "money-bills",
    path: "/ops/billing",
    permission: opsPermissions.contractBill,
  },
  {
    key: "ops.jobs",
    labelKey: "nav.opsJobs",
    icon: "wrench",
    path: "/ops/jobs",
    permission: opsPermissions.jobView,
  },
  {
    key: "ops.projects",
    labelKey: "nav.opsProjects",
    icon: "project-definition-triangle-2",
    path: "/ops/projects",
    permission: opsPermissions.projectView,
  },
  {
    key: "ops.revenue",
    labelKey: "nav.opsRevenue",
    icon: "line-charts",
    path: "/ops/revenue",
    permission: opsPermissions.revenueView,
  },
  {
    key: "ops.lines",
    subGroup: "setup",
    labelKey: "nav.opsLines",
    icon: "action-settings",
    path: "/ops/lines",
    permission: opsPermissions.lineView,
  },
  {
    key: "ops.kinds",
    subGroup: "setup",
    labelKey: "nav.opsKinds",
    icon: "action-settings",
    path: "/ops/kinds",
    permission: opsPermissions.settingsView,
  },
  {
    key: "ops.settings",
    subGroup: "setup",
    labelKey: "nav.opsSettings",
    icon: "settings",
    path: `/platform/settings/${opsSettingsGroup}`,
    permission: opsPermissions.settingsView,
  },
];

/** Icon of the Operations navigation group. */
export const opsGroupIcon = "building";
